import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const parentingTsurai: BlogMetaData = {
  title: '子育てつらい…は弱さじゃない｜しんどさを和らげる5つの視点【モンテッソーリ流】',
  description:
    '「子育てつらい」と感じるのは弱さではありません。比較・孤独・完璧主義…つらさの根っこを整理し、モンテッソーリ流の5つの考え方で心を軽くする方法を解説します。',
  thumbnailUrl: '/img/blog-parenting-tsurai.png',
  filePath: buildBlogFilePath('parenting-tsurai'),
  category: BLOG_CATEGORY.PARENTING,
};
